import injectedModule from "@web3-onboard/injected-wallets";

export default injectedModule();
